export const SECUREAI_HERO_STRAPLINE =
  "SecureAI — Halo-style protection for your AI connection";

export const SECUREAI_CUSTOMER_PROMISE = Object.freeze({
  headline: "Protect your AI connection.",
  description:
    "Private, verified protection for compatible AI coding and agent workflows — powered by the same LightningFlow security discipline behind Halo SuperVPN.",
});

export const SECUREAI_RELEASE = Object.freeze({
  status: "macos_download_dark",
  label: "macOS download",
  cta_label: "macOS download coming soon",
  summary:
    "SecureAI for Mac is coming soon. Public downloads are not yet available. Check back for supported tools and availability.",
});

/** Customer-facing platform rows. Status must stay honest. */
export const SECUREAI_PLATFORMS = Object.freeze([
  Object.freeze({
    name: "Grok Bot",
    status: "In development",
    body: "Grok Bot support is being tested before release.",
  }),
  Object.freeze({
    name: "Claude Code",
    status: "In development",
    body: "Claude Code support is being tested. Public availability is coming soon.",
  }),
  Object.freeze({
    name: "OpenAI Codex",
    status: "Coming soon",
    body: "Codex support is planned. It is not available yet.",
  }),
  Object.freeze({
    name: "Cursor",
    status: "Coming soon",
    body: "Cursor support is planned. It is not available yet.",
  }),
]);

export const SECUREAI_CAPABILITIES = Object.freeze([
  Object.freeze({
    eyebrow: "Protected AI connections",
    title: "Protection on the path out.",
    body: "Guide supported AI-tool traffic through SecureAI so your development context leaves on a controlled path.",
  }),
  Object.freeze({
    eyebrow: "Verified status",
    title: "Protected only when proven.",
    body: "See when a supported connection is protected and when it needs attention.",
  }),
  Object.freeze({
    eyebrow: "Privacy by design",
    title: "Your prompts stay yours.",
    body: "SecureAI is not a content-inspection product. It does not read prompts, source code or tokens.",
  }),
  Object.freeze({
    eyebrow: "Simple by design",
    title: "One app. Your AI tools.",
    body: "Manage supported AI connections in one place, with a clear view of their protection.",
  }),
]);

export const SECUREAI_FAMILY = Object.freeze([
  Object.freeze({
    slug: "halo",
    label: "Halo SuperVPN",
    tagline: "Protect your connection.",
    body: "Private, high-performance protection powered by LightningFlow's QuantumCloak security feature.",
  }),
  Object.freeze({
    slug: "secureshield",
    label: "SecureShield",
    tagline: "Protect your Mac.",
    body: "See your Mac's security settings and follow clear steps to fix what needs attention.",
  }),
  Object.freeze({
    slug: "secureai",
    label: "SecureAI",
    tagline: "Protect your AI connection.",
    body: "Halo-style network protection for compatible AI coding and agent workflows.",
  }),
]);
